const externalLinks: Record<string, string> = {
    topdanmarkDK: 'https://www.topdanmark.dk/',
    insuranceFacts: 'https://www.topdanmark.dk/ipid/',
    insuranceConditions: 'https://www.topdanmark.dk/koebsbetingelser/private-forsikringer/',
    infoProcessing: 'https://www.topdanmark.dk/saadan-anvender-vi-data/'
};

export { externalLinks };
